(function () {
  window.ScentFinder = window.ScentFinder || {};
  if (window.ScentFinder.scriptLoaded) return;
  window.ScentFinder.scriptLoaded = true;

  const selectors = {
    answer: '[data-sf-answer]',
    open: '[data-sf-open]',
    hashOpen: 'a[href="#scent-finder"]'
  };

  const stateBySection = new Map();

  function readData(sectionId) {
    const dataEl = document.getElementById(`ScentFinderData-${sectionId}`);
    if (!dataEl) return null;

    try {
      const data = JSON.parse(dataEl.textContent);
      window.ScentFinderData = window.ScentFinderData || {};
      window.ScentFinderData[sectionId] = data;
      return data;
    } catch (error) {
      console.warn('Scent Finder data could not be parsed.', error);
      return null;
    }
  }

  function getState(sectionId) {
    if (stateBySection.has(sectionId)) return stateBySection.get(sectionId);

    const section = document.querySelector(`[data-sf-section="${sectionId}"]`);
    const drawer = document.getElementById(`ScentFinderDrawer-${sectionId}`);
    const data = readData(sectionId);
    if (!section || !drawer || !data) return null;

    const state = {
      section,
      drawer,
      data,
      currentIndex: 0,
      answers: {},
      selectedCategory: null,
      winnerFragrance: null,
      initialized: false,
      hasStarted: false,
      isLoading: false
    };

    stateBySection.set(sectionId, state);
    return state;
  }

  function initialize(state) {
    if (state.initialized) return;
    state.initialized = true;

    state.section.addEventListener('click', (event) => {
      const answer = event.target.closest(selectors.answer);
      if (answer) {
        selectAnswer(state, answer.dataset.sfAnswer);
        return;
      }

      if (event.target.closest('[data-sf-next]')) {
        goNext(state);
        return;
      }

      if (event.target.closest('[data-sf-start]')) {
        startQuiz(state);
        return;
      }

      if (event.target.closest('[data-sf-previous]')) {
        goPrevious(state);
        return;
      }

      if (event.target.closest('[data-sf-restart]')) {
        restart(state);
        return;
      }

      if (event.target.closest('[data-sf-close]')) {
        closeDrawer(state.drawer);
      }
    });
  }

  function openDrawer(state, opener) {
    initialize(state);
    resetUi(state);
    const hasStoredResult = restoreStoredResult(state);

    if (hasStoredResult) {
      showStoredResult(state);
    } else {
      showIntro(state);
    }

    if (typeof state.drawer.open === 'function') {
      state.drawer.open(opener, state.drawer.querySelector('[data-sf-close]') || state.drawer.querySelector('[data-sf-start]'));
    } else {
      fallbackOpen(state.drawer, opener);
    }
  }

  function fallbackOpen(drawer, opener) {
    const overlay = document.querySelector('.js-overlay');
    drawer.setAttribute('open', '');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.sfOpener = opener;
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('fixed');
    (drawer.querySelector('[data-sf-start]') || drawer.querySelector('[data-sf-close]'))?.focus();
  }

  function closeDrawer(drawer) {
    if (typeof drawer.close === 'function') {
      drawer.close();
      return;
    }

    const overlay = document.querySelector('.js-overlay');
    drawer.removeAttribute('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.classList.remove('fixed');
    drawer.sfOpener?.focus();
  }

  function resetUi(state) {
    state.currentIndex = 0;
    state.answers = {};
    state.selectedCategory = null;
    state.winnerFragrance = null;
    state.hasStarted = false;
    state.isLoading = false;
    setError(state, '');
    state.drawer.querySelector('[data-sf-loading]').hidden = true;
    state.drawer.querySelector('[data-sf-result]').hidden = true;
    state.drawer.querySelector('[data-sf-screen]').hidden = false;
    state.drawer.querySelector('[data-sf-next]').hidden = false;
    state.drawer.querySelector('[data-sf-restart]').hidden = true;
  }

  function restart(state) {
    clearStoredResult(state);
    resetUi(state);
    showIntro(state);
  }

  function showIntro(state) {
    state.hasStarted = false;
    state.drawer.querySelector('[data-sf-intro]').hidden = false;
    state.drawer.querySelector('[data-sf-progress]').hidden = true;
    state.drawer.querySelector('[data-sf-progress-text]').hidden = true;
    state.drawer.querySelector('[data-sf-screen]').hidden = true;
    state.drawer.querySelector('[data-sf-footer]').hidden = true;
    state.drawer.querySelector('[data-sf-loading]').hidden = true;
    state.drawer.querySelector('[data-sf-result]').hidden = true;
    state.drawer.querySelector('[data-sf-start]')?.focus();
  }

  function startQuiz(state) {
    clearStoredResult(state);
    state.hasStarted = true;
    state.drawer.querySelector('[data-sf-intro]').hidden = true;
    state.drawer.querySelector('[data-sf-progress]').hidden = false;
    state.drawer.querySelector('[data-sf-progress-text]').hidden = false;
    state.drawer.querySelector('[data-sf-screen]').hidden = false;
    state.drawer.querySelector('[data-sf-footer]').hidden = false;
    state.drawer.querySelector('[data-sf-result]').hidden = true;
    renderQuestion(state);
  }

  function getCurrentQuestion(state) {
    return state.data.questions[state.currentIndex];
  }

  function selectAnswer(state, answerId) {
    const question = getCurrentQuestion(state);
    if (!question) return;

    state.answers[question.id] = answerId;
    setError(state, '');
    renderQuestion(state);
  }

  function goPrevious(state) {
    if (state.isLoading || state.currentIndex <= 0) return;
    state.currentIndex -= 1;
    renderQuestion(state);
  }

  function goNext(state) {
    const question = getCurrentQuestion(state);
    if (!question) return;

    const answerId = state.answers[question.id];
    if (!answerId) {
      setError(state, 'Choose an answer to continue.');
      return;
    }

    if (state.currentIndex < state.data.questions.length - 1) {
      state.currentIndex += 1;
      renderQuestion(state);
      return;
    }

    showLoadingThenResult(state);
  }

  function renderQuestion(state) {
    const question = getCurrentQuestion(state);
    const screen = state.drawer.querySelector('[data-sf-screen]');
    const previous = state.drawer.querySelector('[data-sf-previous]');
    const next = state.drawer.querySelector('[data-sf-next]');

    if (!question) {
      screen.innerHTML = '<p class="sf-empty">Add Scent Finder questions in the Theme Customizer.</p>';
      previous.hidden = true;
      next.disabled = true;
      updateProgress(state);
      return;
    }

    const selectedAnswerId = state.answers[question.id];
    screen.innerHTML = questionMarkup(question, selectedAnswerId);
    previous.hidden = state.currentIndex === 0;
    next.disabled = !selectedAnswerId;
    next.textContent = state.currentIndex === state.data.questions.length - 1 ? 'Show my match' : 'Next';
    updateProgress(state);
  }

  function questionMarkup(question, selectedAnswerId) {
    const image = question.image?.src
      ? `<div class="sf-question__media"><img src="${escapeAttribute(question.image.src)}" alt="${escapeAttribute(question.image.alt || '')}" loading="lazy"></div>`
      : '';

    const description = question.description
      ? `<p class="sf-question__description">${escapeHtml(question.description)}</p>`
      : '';

    const answers = question.answers.map((answer) => {
      const pressed = answer.id === selectedAnswerId ? 'true' : 'false';
      const answerImage = answer.image?.src
        ? `<span class="sf-answer__media"><img src="${escapeAttribute(answer.image.src)}" alt="${escapeAttribute(answer.image.alt || '')}" loading="lazy"></span>`
        : '';
      const answerText = answerTextMarkup(answer);

      return `
        <button type="button" class="sf-answer" data-sf-answer="${escapeAttribute(answer.id)}" aria-pressed="${pressed}">
          ${answerImage}
          ${answerText}
          <span class="sf-answer__mark" aria-hidden="true"></span>
        </button>
      `;
    }).join('');

    return `
      <article class="sf-question${question.type === 'category' ? ' sf-question--category' : ''}">
        ${image}
        <h3 class="sf-question__title">${escapeHtml(question.title || '')}</h3>
        ${description}
        <div class="sf-answers" role="list">${answers}</div>
      </article>
    `;
  }

  function answerTextMarkup(answer) {
    const label = answer?.label || '';
    if (answer?.subtext) {
      return `
        <span class="sf-answer__label font-bold">${escapeHtml(label)}</span>
        <span class="sf-answer__subtext">${escapeHtml(answer.subtext)}</span>
      `;
    }

    const parts = String(label || '').split(/\s+-\s+/);
    const title = parts.shift() || '';
    const subtitle = parts.join(' - ');

    if (!subtitle) return `<span class="sf-answer__label font-bold">${escapeHtml(label)}</span>`;

    return `
      <span class="sf-answer__label font-bold">${escapeHtml(title)}</span>
      ${subtitle ? `<span class="sf-answer__subtext">${escapeHtml(subtitle)}</span>` : ''}
    `;
  }

  function updateProgress(state) {
    const total = state.data.questions.length;
    const current = total ? state.currentIndex + 1 : 0;
    const percent = total ? current / total : 0;
    const bar = state.drawer.querySelector('[data-sf-progress-bar]');
    const text = state.drawer.querySelector('[data-sf-progress-text]');
    bar.style.transform = `scaleX(${percent})`;
    text.textContent = total ? `Question ${current} of ${total}` : 'No questions configured';
  }

  function showLoadingThenResult(state) {
    state.isLoading = true;
    state.drawer.querySelector('[data-sf-screen]').hidden = true;
    state.drawer.querySelector('[data-sf-loading]').hidden = false;
    state.drawer.querySelector('[data-sf-next]').hidden = true;
    state.drawer.querySelector('[data-sf-previous]').hidden = true;
    setError(state, '');

    window.setTimeout(async () => {
      calculateResult(state);
      saveStoredResult(state);
      await renderResult(state);
      state.drawer.querySelector('[data-sf-loading]').hidden = true;
      state.isLoading = false;
    }, Number(state.data.settings.loadingDuration) || 1600);
  }

  function calculateResult(state) {
    const scores = {};

    state.data.fragrances.forEach((fragrance) => {
      scores[fragrance.id] = 0;
    });

    state.data.questions.forEach((question) => {
      const answer = question.answers.find((item) => item.id === state.answers[question.id]);
      if (!answer) return;

      if (question.type === 'category') {
        state.selectedCategory = getCategoryFromAnswer(answer);
        return;
      }

      parseScoreMapping(answer.scoreMapping).forEach((mapping) => {
        scores[mapping.id] = (scores[mapping.id] || 0) + mapping.value;
      });
    });

    state.winnerFragrance = state.data.fragrances.reduce((winner, fragrance) => {
      if (!winner) return fragrance;
      return (scores[fragrance.id] || 0) > (scores[winner.id] || 0) ? fragrance : winner;
    }, null);
  }

  function parseScoreMapping(value) {
    return String(value || '')
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => {
        const parts = line.split('==');
        return {
          id: (parts[0] || '').trim(),
          value: Number((parts[1] || '').trim()) || 0
        };
      })
      .filter((mapping) => mapping.id);
  }

  function getCategoryFromAnswer(answer) {
    const label = String(answer?.label || '').toLowerCase();
    if (label.includes('diffuser')) return 'diffuser';
    if (label.includes('candle')) return 'candle';
    return null;
  }

  async function showStoredResult(state) {
    state.hasStarted = true;
    state.drawer.querySelector('[data-sf-intro]').hidden = true;
    state.drawer.querySelector('[data-sf-progress]').hidden = true;
    state.drawer.querySelector('[data-sf-progress-text]').hidden = true;
    state.drawer.querySelector('[data-sf-screen]').hidden = true;
    state.drawer.querySelector('[data-sf-footer]').hidden = true;
    state.drawer.querySelector('[data-sf-loading]').hidden = false;

    await renderResult(state);
    state.drawer.querySelector('[data-sf-loading]').hidden = true;
  }

  function restoreStoredResult(state) {
    const storedResult = readStoredResult(state);
    if (!storedResult) return false;

    const fragrance = state.data.fragrances.find((item) => item.id === storedResult.fragranceId);
    const category = storedResult.category === 'diffuser' ? 'diffuser' : 'candle';
    if (!fragrance?.products?.[category]) {
      clearStoredResult(state);
      return false;
    }

    state.winnerFragrance = fragrance;
    state.selectedCategory = category;
    return true;
  }

  function saveStoredResult(state) {
    const category = state.selectedCategory || 'candle';
    if (!state.winnerFragrance?.products?.[category]) return;

    writeSessionValue(getStorageKey(state), {
      fragranceId: state.winnerFragrance.id,
      category
    });
  }

  function readStoredResult(state) {
    const value = readSessionValue(getStorageKey(state));
    if (!value || typeof value !== 'object') return null;
    if (!value.fragranceId) return null;
    return value;
  }

  function clearStoredResult(state) {
    try {
      window.sessionStorage?.removeItem(getStorageKey(state));
      window.sessionStorage?.removeItem(getLegacyStorageKey(state));
    } catch (error) {
      // Storage can be unavailable in some private browsing modes.
    }
  }

  function getStorageKey(state) {
    return 'scentFinderResult';
  }

  function getLegacyStorageKey(state) {
    return `scentFinderResult:${state.data.sectionId || state.section.dataset.sfSection}`;
  }

  function readSessionValue(key) {
    try {
      const value = window.sessionStorage?.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function writeSessionValue(key, value) {
    try {
      window.sessionStorage?.setItem(key, JSON.stringify(value));
    } catch (error) {
      // Ignore storage failures so the quiz still works normally.
    }
  }

  async function renderResult(state) {
    const result = state.drawer.querySelector('[data-sf-result]');
    const footer = state.drawer.querySelector('[data-sf-footer]');
    const progressText = state.drawer.querySelector('[data-sf-progress-text]');
    const category = state.selectedCategory || 'candle';
    const fragrance = state.winnerFragrance;
    const mainProduct = fragrance?.products?.[category];
    const candleProduct = fragrance?.products?.candle;
    const diffuserProduct = fragrance?.products?.diffuser;

    result.hidden = true;
    footer.hidden = true;
    progressText.hidden = true;

    if (!fragrance || !mainProduct) {
      result.innerHTML = '<p class="sf-empty">No matching product is configured for this result yet.</p>';
      result.hidden = false;
      return;
    }

    const resultSubtext = fragrance.resultSubtext || state.data.settings.resultSubheading || '';

    result.innerHTML = `
      <header class="sf-result-hero">
        <h3 class="sf-result-hero__title">We found your scent: <span>${escapeHtml(fragrance.displayName)}</span></h3>
        ${resultSubtext ? `<p class="sf-result-hero__text">${escapeHtml(resultSubtext)}</p>` : ''}
      </header>
      <article class="sf-result-product">
          <a href="${escapeHtml(mainProduct.url)}" class="sf-result-product__media">
            <span class="sf-result-product__badge">Recommended</span>
            ${productImageMarkup(mainProduct)}
          </a>
        <div class="sf-result-product__details">
          <a href="${escapeHtml(mainProduct.url)}"><h4 class="sf-result-product__title">${escapeHtml(mainProduct.title)}</h4></a>
          ${priceMarkup(mainProduct)}
          ${moodScentMarkup(mainProduct)}
          <button type="button" class="sf-btn sf-btn--primary sf-result-product__button" data-sf-add="${mainProduct.variant.id}" ${!mainProduct.variant.available ? 'disabled' : ''}>Add to Basket</button>
        </div>
      </article>
      ${candleProduct && diffuserProduct ? bundleMarkup(candleProduct, diffuserProduct, state.data.settings.bundleDiscountPercentage, category) : ''}
      <button type="button" class="sf-result__restart" data-sf-restart>Retake the quiz</button>
    `;

    await waitForResultImages(result);
    result.hidden = false;
  }

  async function waitForResultImages(container) {
    const images = Array.from(container.querySelectorAll('img'));

    await Promise.all(images.map(waitForImage));
    if (document.fonts?.ready) {
      await withTimeout(document.fonts.ready.catch(() => {}), 700);
    }
    await nextFrame();
    await nextFrame();
  }

  async function waitForImage(image) {
    if (!image.complete) {
      await withTimeout(new Promise((resolve) => {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      }), 1200);
    }

    if (image.complete && image.naturalWidth && typeof image.decode === 'function') {
      await withTimeout(image.decode().catch(() => {}), 700);
    }
  }

  function withTimeout(promise, delay) {
    return Promise.race([
      promise,
      new Promise((resolve) => window.setTimeout(resolve, delay))
    ]);
  }

  function nextFrame() {
    return new Promise((resolve) => window.requestAnimationFrame(() => resolve()));
  }

  function moodScentMarkup(product) {
    if (!product.mood && !product.scent) return '';

    return `
      <div class="sf-result-product__notes">
        ${product.mood ? `<p><strong>Mood:</strong> ${escapeHtml(product.mood)}</p>` : ''}
        ${product.scent ? `<p><strong>Scent:</strong> ${escapeHtml(product.scent)}</p>` : ''}
      </div>
    `;
  }

  function bundleMarkup(candleProduct, diffuserProduct, discountPercentage, selectedCategory) {
    const totalPrice = candleProduct.variant.price + diffuserProduct.variant.price;
    const discount = Math.min(Math.max(Number(discountPercentage) || 0, 0), 100);
    const bundlePrice = Math.round(totalPrice * ((100 - discount) / 100));
    const priceMarkup = discount > 0
      ? `<span>${formatMoney(bundlePrice)}</span><s>${formatMoney(totalPrice)}</s>`
      : `<span>${formatMoney(totalPrice)}</span>`;
    const bundleText = selectedCategory === 'diffuser'
      ? 'Pair it with our soy wax candle to enjoy the full fragrance throughout your space.'
      : 'Pair it with our reed diffuser to enjoy the full fragrance throughout your space.';

    return `
      <div class="sf-bundle">
        <header class="sf-bundle__header">
          <h4 class="sf-bundle__title">Complete The Set${discount > 0 ? ` and Save ${discount}%` : ''}</h4>
          <p class="sf-bundle__text">${escapeHtml(bundleText)}</p>
        </header>
        <div class="sf-bundle__pair">
          ${bundleItemMarkup(candleProduct, 'Candle')}
          <span class="sf-bundle__plus" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
          </svg>
          </span>
          ${bundleItemMarkup(diffuserProduct, 'Diffuser')}
        </div>
        <button type="button" class="sf-btn sf-btn--primary sf-bundle__button" data-sf-bundle-add data-main-variant="${candleProduct.variant.id}" data-bundle-variant="${diffuserProduct.variant.id}" ${!candleProduct.variant.available || !diffuserProduct.variant.available ? 'disabled' : ''}>
          <span>Add Set to Basket</span>
          ${priceMarkup}
        </button>
      </div>
    `;
  }

  function bundleItemMarkup(product, label) {
    return `
      <article class="sf-bundle-item">
        <a href="${escapeHtml(product.url)}" class="sf-bundle-item__media">${productImageMarkup(product)}</a>
        <a href="${escapeHtml(product.url)}"><h5 class="sf-bundle-item__title font-bold">${escapeHtml(product.title)}</h5></a>
        ${priceMarkup(product)}
      </article>
    `;
  }

  function productImageMarkup(product) {
    const width = product.featuredImage?.width ? ` width="${escapeAttribute(product.featuredImage.width)}"` : '';
    const height = product.featuredImage?.height ? ` height="${escapeAttribute(product.featuredImage.height)}"` : '';

    return product.featuredImage?.src
      ? `<img src="${escapeAttribute(product.featuredImage.src)}" alt="${escapeAttribute(product.featuredImage.alt || product.title)}" loading="eager" decoding="async" fetchpriority="high"${width}${height}>`
      : '';
  }

  function priceMarkup(product) {
    const compareAt = product.variant.compareAtPrice && product.variant.compareAtPrice > product.variant.price
      ? `<span class="sf-product-card__compare">${escapeHtml(product.variant.compareAtPriceFormatted)}</span>`
      : '';

    return `
      <p class="sf-product-card__price">
        <span>${escapeHtml(product.variant.priceFormatted)}</span>
        ${compareAt}
      </p>
    `;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    const amount = (Number(cents) || 0) / 100;
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: window.theme?.settings?.currencyCode || 'GBP'
    }).format(amount);
  }

  function productMarkup(product, options) {
    const compareAt = product.variant.compareAtPrice && product.variant.compareAtPrice > product.variant.price
      ? `<span class="sf-product-card__compare">${escapeHtml(product.variant.compareAtPriceFormatted)}</span>`
      : '';
    const image = product.featuredImage?.src
      ? `<a class="sf-product-card__media" href="${escapeAttribute(product.url)}"><img src="${escapeAttribute(product.featuredImage.src)}" alt="${escapeAttribute(product.featuredImage.alt || product.title)}" loading="lazy"></a>`
      : '';
    const addButton = options.primary
      ? `<button type="button" class="sf-btn sf-btn--primary" data-sf-add="${product.variant.id}" ${!product.variant.available ? 'disabled' : ''}>${escapeHtml(options.buttonLabel)}</button>`
      : '';

    return `
      <article class="sf-product-card">
        ${image}
        <div class="sf-product-card__body">
          <h4 class="sf-product-card__title"><a href="${escapeAttribute(product.url)}">${escapeHtml(product.title)}</a></h4>
          <p class="sf-product-card__price">
            <span>${escapeHtml(product.variant.priceFormatted)}</span>
            ${compareAt}
          </p>
          <p class="sf-product-card__availability" data-available="${product.variant.available ? 'true' : 'false'}">${product.variant.available ? 'In stock' : 'Out of stock'}</p>
          <div class="sf-product-card__actions">
            ${addButton}
            <a class="sf-btn sf-btn--secondary" href="${escapeAttribute(product.url)}">View product</a>
          </div>
        </div>
      </article>
    `;
  }

  async function addItems(state, items, button) {
    if (!items.length || button?.disabled) return;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';
    setError(state, '');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add to cart.');

      closeDrawer(state.drawer);
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    } catch (error) {
      setError(state, error.message || 'Unable to add to cart.');
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  function setError(state, message) {
    const error = state.drawer.querySelector('[data-sf-error]');
    error.hidden = !message;
    error.textContent = message;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }[char]));
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  function openFirstDrawer(opener) {
    const section = document.querySelector('[data-sf-section]');
    if (!section) return false;

    const state = getState(section.dataset.sfSection);
    if (!state) return false;

    openDrawer(state, opener || document.querySelector(`[data-sf-open="${section.dataset.sfSection}"]`));
    return true;
  }

  function openDrawerFromHash() {
    if (window.location.hash !== '#scent-finder') return;
    openFirstDrawer(document.querySelector(selectors.hashOpen));
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest(selectors.open);
    if (opener) {
      const state = getState(opener.dataset.sfOpen);
      if (state) openDrawer(state, opener);
      return;
    }

    const hashOpener = event.target.closest(selectors.hashOpen);
    if (hashOpener) {
      event.preventDefault();
      openFirstDrawer(hashOpener);
      if (window.location.hash !== '#scent-finder') {
        window.history.pushState(null, '', '#scent-finder');
      }
      return;
    }

    const addButton = event.target.closest('[data-sf-add]');
    const bundleButton = event.target.closest('[data-sf-bundle-add]');
    if (!addButton && !bundleButton) return;

    const section = event.target.closest('[data-sf-section]');
    if (!section) return;

    const state = getState(section.dataset.sfSection);
    if (!state) return;

    if (addButton) {
      addItems(state, [{ id: Number(addButton.dataset.sfAdd), quantity: 1 }], addButton);
      return;
    }

    addItems(state, [
      { id: Number(bundleButton.dataset.mainVariant), quantity: 1 },
      { id: Number(bundleButton.dataset.bundleVariant), quantity: 1 }
    ], bundleButton);
  });

  window.ScentFinder.open = function (sectionId) {
    const state = getState(sectionId);
    if (state) openDrawer(state, document.querySelector(`[data-sf-open="${sectionId}"]`));
  };

  window.addEventListener('hashchange', openDrawerFromHash);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openDrawerFromHash);
  } else {
    openDrawerFromHash();
  }
})();
